import { AnimatePresence, motion } from 'motion/react'
import { Drawer } from 'vaul'
import useLockBodyScroll from '@/hooks/useLockBodyScroll'
import useEscapeKey from '@/hooks/useEscapeKey'
import useIsDesktop from '@/hooks/useIsDesktop'

export default function ResponsiveModal({ isOpen, onClose, desktopClassName, children }) {
    const isDesktop = useIsDesktop()
    useLockBodyScroll(isOpen && isDesktop)
    useEscapeKey(isOpen, onClose)

    if (!isDesktop) {
        return (
            <Drawer.Root
                open={isOpen}
                onOpenChange={(open) => { if (!open) onClose() }}
            >
                <Drawer.Portal>
                    <Drawer.Overlay className="fixed inset-0 bg-black/10 backdrop-blur-[20px] z-30" />
                    <Drawer.Content className="fixed bottom-0 left-0 right-0 z-40 bg-white rounded-t-[16px] max-h-[95vh] flex flex-col outline-none">
                        <div className="flex justify-center pt-[12px] pb-[4px]">
                            <div className="w-[36px] h-[4px] rounded-full bg-dark-blue-10" />
                        </div>
                        {children}
                    </Drawer.Content>
                </Drawer.Portal>
            </Drawer.Root>
        )
    }

    return (
        <AnimatePresence>
            {isOpen && (
                <>
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={onClose}
                        className="fixed inset-0 bg-black/10 backdrop-blur-[20px] z-30"
                    />

                    <motion.div
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        transition={{ duration: 0.15 }}
                        className={`fixed z-40 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-[16px] overflow-hidden ${desktopClassName ?? ''}`}
                    >
                        {children}
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    )
}
